/**
 * Reads the one-time token out of the URL a user arrived on from an email.
 *
 * NEW LINKS carry it in the FRAGMENT — `…/reset-password#token=…` — because a
 * fragment is never sent to any server: it is not in the dashboard host's
 * access log and not in the `Referer` of a request the page makes afterwards.
 * The page reads it here, in the browser, and posts it in a request body.
 *
 * LINKS SENT BEFORE THIS LOT carry it in the query string (`?token=…`); they
 * are still honoured so a message already sitting in someone's inbox keeps
 * working until its token expires. The fragment wins if both are present.
 *
 * Returns `null` for anything that cannot be a token: absent, empty, or outside
 * the length the API accepts (16–512 characters), so the page shows « lien
 * invalide » without a network round trip.
 */
export function readTokenFromUrl(hash: string, search: string): string | null {
  const fromFragment = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash).get(
    'token',
  );
  const fromQuery = new URLSearchParams(search).get('token');
  const token = fromFragment ?? fromQuery;

  if (token === null || token.length < 16 || token.length > 512) return null;
  return token;
}

/**
 * Removes the token from the address bar once it has been read, so it does not
 * stay in the browser history, a copied URL or a screenshot. Keeps the path.
 */
export function clearTokenFromUrl(): void {
  window.history.replaceState(window.history.state, '', window.location.pathname);
}
